<template>
  <div v-if="items" v-bind:class="{ 'hidden': !isItemsOpen }">
    <div v-for="item in items" v-bind:key="item.id">
      <div v-if="token !== null || item.type !== 'favorite'" class="p-4 border-b border-pale_green flex items-center" v-bind:class="{ 'hidden': !item.filter }">
        <div v-if="icon(item) !== undefined" class="hidden">
          <img :src="icon(item)" class="h-6 w-8 flex-shrink-0">
        </div>
        <div v-else class="hidden">
          <svg
            class="fill-current text-gray-500 h-6 w-8 flex-shrink-0"
            version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 1006">
            <path d="M285.5.6c-27.6 2.8-39.2 4.7-59 9.9-85.3 22.2-156.3 79.8-195.8 159C.8 229.5-7.8 303 7.5 367c7.6 31.6 16.5 52.4 41.3 97 26.9 48.4 31.5 55.9 78.7 128.5 11.1 17 25.6 39.5 32.2 50 76.8 121.4 121.8 227 147.4 345.9 1.5 6.8 1.8 6.2 4.4-6.4 10.4-52.4 32.5-120.6 56.8-175.5 30.2-68.2 61.2-122.7 126-221.4 45-68.8 56.6-88.2 79.1-133.1 25.3-50.2 30.4-63.6 37-96 6.9-34 6.5-77.4-1-115-11.5-57.5-41.7-112-86-155.1C476.3 40.2 415.6 11.6 346 2.5 334.2 1 294.4-.3 285.5.6z" />
          </svg>
        </div>
        <span class="flex-grow" :class="fontWeight">
          <span>
            {{ item.filterName }}
          </span>
          <div v-if="item.filterCaptions" class="text-sm">
            <div v-for="(filterCaption, index) in item.filterCaptions" v-bind:key="index">
              {{ filterCaption }}
            </div>
          </div>
        </span>
        <div v-if="existChild(item)" @click="changeViewChild(item)">
          <div v-if="item.isItemsOpen">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 10l5 5 5-5z"/></svg>
          </div>
          <div v-else>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M14 7l-5 5 5 5V7z"/><path d="M24 0v24H0V0h24z" fill="none"/></svg>
          </div>
        </div>
        <div class="relative ml-2 rounded-full w-12 h-6 transition duration-200 ease-linear flex-shrink-0"
          :class="isOn(item) ? 'bg-gray-300' : 'bg-gray-300'"
          :id = item.id
          @click="onToggle(item)">
          <label for="toggle"
            class="absolute left-0 bg-white border-2 mb-2 w-6 h-6 rounded-full transition transform duration-100 ease-linear cursor-pointer"
            :class="isOn(item) ? 'translate-x-full bg-link border-gray-300' : 'translate-x-0 border-gray-400 border-opacity-60'"></label>
          <input type="checkbox"
            class="appearance-none w-full h-full active:outline-none focus:outline-none"/>
        </div>
      </div>
      <filter-button
        class="ml-4"
        :items="item.items"
        :isItemsOpen="item.isItemsOpen" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterButton from './FilterButton'

export default {
  name: 'filter-button',
  components: {
    FilterButton
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    isItemsOpen: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    fontWeight: {
      type: String,
      default: function () {
        return 'font-normal'
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken',
      genres: 'genres/getAll'
    })
  },
  methods: {
    onToggle: function (genre) {
      if (!this.$store.getters['user/isFilterOn'](genre)) {
        this.$store.dispatch('user/onFilter', genre)
        if(genre.items){
          genre.items.forEach(child => {
            this.$store.dispatch('user/onFilter', child)
            if(child.items){
              this.changeChildOn(child.items)
            }
          });
        }
      } else {
        if (genre.exlusive !== undefined && genre.exlusive === true) {
          this.$store.dispatch('user/setFilter', this.genres)
        } else {
          this.$store.dispatch('user/offFilter', genre)
          if(genre.items){
            genre.items.forEach(child => {
              this.$store.dispatch('user/offFilter', child)
              if(child.items){
                this.changeChildOff(child.items)
              }
            });
          }
        }
      }
    },
    changeChildOn: function (items) {
      items.forEach(child => {
        this.$store.dispatch('user/onFilter', child)
        var findelement = document.getElementById(child.id)
        findelement.toggle = true
        if(child.items){
          this.changeChildOn(child.items)
        }
      });
    },
    changeChildOff: function (items) {
      items.forEach(child => {
        this.$store.dispatch('user/offFilter', child)
        var findelement = document.getElementById(child.id)
        findelement.toggle = true
        if(child.items){
          this.changeChildOn(child.items)
        }
      });
    },
    isOn: function (genre) {
      return this.$store.getters['user/isFilterOn'](genre)
    },
    icon: function (genre) {
      return this.iconPath(genre)
    },
    iconPath(genre) {
      return genre.filterIcon
    },
    existChild: function (genre) {
      if(genre.items){
        for (let i = 0; i < genre.items.length; i++) {
          if (genre.items[i].filter) {
            return true
          }
        }
      }
      return false
    },
    changeViewChild: function (genre) {
      genre.isItemsOpen = !genre.isItemsOpen
    }
  }
}
</script>
